class BfvConditionalFormFields {
  constructor(options = {}) {
    this.$root = options.element;
    this.fieldConditions = JSON.parse(this.$root.getAttribute('data-conditions-json')).fields;
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    const condFieldNames = [];

    // get all distinct condition names
    this.fieldConditions.forEach((conditionItem) => {
      if (condFieldNames.indexOf(conditionItem.condname) === -1) {
        condFieldNames.push(conditionItem.condname);
      }
    });

    // for each condition, add change listener to the associated fields
    condFieldNames.forEach((condname) => {
      const $fields = this.$root.querySelectorAll(`[name=${condname}]`);

      $fields.forEach(($field) => {
        $field.addEventListener('change', (event) => {
          this.handleChangeEvent(event);
        });

        BfvConditionalFormFields.triggerChangeEvent($field);
      });
    });
  }

  /**
   * triggers change event to initialize
   * @param $triggeringElement
   */
  static triggerChangeEvent($triggeringElement) {
    let eventObject;
    if (typeof (Event) === 'function') {
      eventObject = new Event('change');
    } else {
      eventObject = document.createEvent('Event');
      eventObject.initEvent('change', true, true);
    }

    $triggeringElement.dispatchEvent(eventObject);
  }

  /**
   * handles changed conditions
   * @param event
   */
  handleChangeEvent(event) {
    const fieldName = event.target.getAttribute('name');
    const selectedValue = BfvConditionalFormFields.getSelectedValue(event.target);

    this.fieldConditions.forEach((conditionItem) => {
      if (conditionItem.condname === fieldName && conditionItem.condtype === 'visibility') {
        const $field = this.$root.querySelector(`[name=${conditionItem.name}]`);
        const $fieldWrapper = $field.closest('.bfv-formular__input-wrapper');
        const condFieldValue = conditionItem.condvalue;
        const condNegated = conditionItem.condnegated;

        // hide or show Fields depending on the selection
        if ((selectedValue === condFieldValue && !condNegated) || (selectedValue !== condFieldValue && condNegated)) {
          $fieldWrapper.style.display = 'block';
        } else {
          $fieldWrapper.style.display = 'none';
        }
      }
    });
  }

  /**
   * returns Value of an Element, depending on it's type (select / radio)
   * @param $changedElement
   * @returns string
   */
  static getSelectedValue($changedElement) {
    const { tagName } = $changedElement;

    if (tagName === 'SELECT') {
      return $changedElement.options[$changedElement.selectedIndex].value;
    } if (tagName === 'INPUT' && $changedElement.type === 'radio' && $changedElement.checked) {
      return $changedElement.value;
    }

    return '';
  }
}

export default BfvConditionalFormFields;
